class BgMusic{
    constructor(container){
        this.container = container;
        this.playing = true;
        this.toggler = document.getElementsByClassName('j-music-toggle');
        this.videos = 0;

        this.init();
    }

    init(){
        const cmp = this;

        let vid = document.getElementsByClassName('j-video');
        for(let i=0; i<vid.length; i++){
            videojs(vid[i].getElementsByTagName('video')[0]).on('play', function(){
                cmp.videos++;
                console.log(cmp.videos);
                cmp.container.pause();
            });
            videojs(vid[i].getElementsByTagName('video')[0]).on('pause', function(){
                cmp.videos--;
                console.log(cmp.videos);
                if(cmp.videos < 1){
                    if(cmp.playing){
                        cmp.container.play();
                    }
                }
            });
        }

        let svid = document.getElementsByClassName('j-small-video');
        for(let i=0; i<svid.length; i++){
            videojs(svid[i].getElementsByTagName('video')[0]).on('play', function(){
                cmp.videos++;
                console.log(cmp.videos);
                cmp.container.pause();
            });
            videojs(svid[i].getElementsByTagName('video')[0]).on('pause', function(){
                cmp.videos--;
                console.log(cmp.videos);
                if(cmp.videos < 1){
                    if(cmp.playing){
                        cmp.container.play();
                    }
                }
            });
        }

        let sidevid = document.getElementsByClassName('j-side-video');
        for(let i=0; i<sidevid.length; i++){
            videojs(sidevid[i].getElementsByTagName('video')[0]).on('play', function(){
                cmp.videos++;
                console.log(cmp.videos);
                cmp.container.pause();
            });
            videojs(sidevid[i].getElementsByTagName('video')[0]).on('pause', function(){
                cmp.videos--;
                console.log(cmp.videos);
                if(cmp.videos < 1){
                    if(cmp.playing){
                        cmp.container.play();
                    }
                }
            });
        }

        document.addEventListener('music.start', function(){
            if(cmp.playing){
                cmp.container.play();
            }
        });

        for(let i=0; i<cmp.toggler.length; i++){
            cmp.toggler[i].addEventListener('click', function(){
                if(cmp.playing){
                    cmp.container.pause();
                    cmp.playing = false;
                    for(let j=0; j<cmp.toggler.length; j++){
                        cmp.toggler[j].classList.add('_pause');
                    }
                }
                else{
                    cmp.container.play();
                    if(cmp.videos < 1){
                        cmp.playing = true;
                    }
                    for(let j=0; j<cmp.toggler.length; j++){
                        cmp.toggler[j].classList.remove('_pause');
                    }
                }
            });
        }

        document.addEventListener('music.toggle', function(){
            cmp.playing = !cmp.playing;
            if(!cmp.playing){
                cmp.container.pause();
            }
        });
    }
}

export default BgMusic;